import React, { useState } from 'react';
import { ILegalRequirementTemplateFullObject } from '../Interfaces/ILegalRequirementTemplate';
import {
  Checkbox,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { ArrowDownward, ArrowUpward, Edit } from '@mui/icons-material';
import { ConfirmDelete } from '../core/ConfirmDelete';
import { ILegalPhaseTemplateFullObject } from '../Interfaces/ILegalPhaseTemplate';
import { EditLegalRequirementTemplate } from './EditLegalRequirementTemplate';

interface IProps {
  currentRequirement: ILegalRequirementTemplateFullObject;
  legalRequirementArray: ILegalRequirementTemplateFullObject[];
  setLegalRequirementArray: Function;
  legalPhaseTemplateArray?: ILegalPhaseTemplateFullObject[];
  selectedRequirementsIds: number[];
  setSelectedRequirementsIds: Function;
  currentLegalPhaseTemplate: ILegalPhaseTemplateFullObject;
}

export const LegalRequirementTemplateRow: React.FC<IProps> = ({
  currentRequirement,
  legalRequirementArray,
  setLegalRequirementArray,
  legalPhaseTemplateArray,
  selectedRequirementsIds,
  setSelectedRequirementsIds,
  currentLegalPhaseTemplate,
}) => {
  const [currentRequirementTemplateEdit, setCurrentRequirementTemplateEdit] =
    useState(
      currentRequirement.DocumentArray
        ? currentRequirement
        : { ...currentRequirement, DocumentArray: [] }
    );
  //
  const [
    isOpenEditLegalRequirementTemplate,
    setIsOpenEditLegalRequirementTemplate,
  ] = useState(
    currentRequirement.idLegalRequirementTemplate < 0 &&
      currentRequirement.LegalRequirementTemplate === ''
  );

  const isFirstDisabled = () => {
    const currentIndex: number = legalRequirementArray
      .map(x => x.idLegalRequirementTemplate)
      .indexOf(currentRequirement.idLegalRequirementTemplate);
    return currentIndex === 0;
  };

  const isLastDisabled = () => {
    const currentIndex: number = legalRequirementArray
      .map(x => x.idLegalRequirementTemplate)
      .indexOf(currentRequirement.idLegalRequirementTemplate);
    return currentIndex === legalRequirementArray.length - 1;
  };

  const getUp = () => {
    const copyOfArray = [...legalRequirementArray];
    const targetPositionn = currentRequirementTemplateEdit.Position - 1;
    const toChangeObject = copyOfArray.find(
      x => x.Position === targetPositionn
    );
    const currentObject = { ...currentRequirementTemplateEdit };

    if (toChangeObject !== undefined) {
      const currentIndex = legalRequirementArray
        .map(x => x.idLegalRequirementTemplate)
        .indexOf(currentObject.idLegalRequirementTemplate);
      const targetIndex = legalRequirementArray
        .map(x => x.idLegalRequirementTemplate)
        .indexOf(toChangeObject.idLegalRequirementTemplate);

      copyOfArray[currentIndex].Position =
        copyOfArray[currentIndex].Position - 1;
      copyOfArray[targetIndex].Position = copyOfArray[targetIndex].Position + 1;

      setLegalRequirementArray(copyOfArray);
    }
  };

  const getDown = () => {
    const copyOfArray = [...legalRequirementArray];
    const targetPositionn = currentRequirementTemplateEdit.Position + 1;
    const toChangeObject = copyOfArray.find(
      x => x.Position === targetPositionn
    );
    const currentObject = { ...currentRequirementTemplateEdit };

    if (toChangeObject !== undefined) {
      const currentIndex = legalRequirementArray
        .map(x => x.idLegalRequirementTemplate)
        .indexOf(currentObject.idLegalRequirementTemplate);
      const targetIndex = legalRequirementArray
        .map(x => x.idLegalRequirementTemplate)
        .indexOf(toChangeObject.idLegalRequirementTemplate);

      copyOfArray[currentIndex].Position =
        copyOfArray[currentIndex].Position + 1;
      copyOfArray[targetIndex].Position = copyOfArray[targetIndex].Position - 1;

      setLegalRequirementArray(copyOfArray);
    }
  };

  const handleDelete = () => {
    setLegalRequirementArray([
      ...legalRequirementArray.filter(
        x =>
          x.idLegalRequirementTemplate !==
          currentRequirement.idLegalRequirementTemplate
      ),
    ]);
  };

  const handleCheckboxChange = () => {
    const id = currentRequirement.idLegalRequirementTemplate;
    const updatedSelected = selectedRequirementsIds.includes(id)
      ? selectedRequirementsIds.filter(reqId => reqId !== id)
      : [...selectedRequirementsIds, id];
    setSelectedRequirementsIds(updatedSelected);
  };

  return (
    <>
      <EditLegalRequirementTemplate
        isOpenEditLegalRequirementTemplate={isOpenEditLegalRequirementTemplate}
        setIsOpenEditLegalRequirementTemplate={
          setIsOpenEditLegalRequirementTemplate
        }
        updateLegalRequirementTemplateArray={setLegalRequirementArray}
        currentLegalPhaseTemplate={currentLegalPhaseTemplate}
        legalPhaseTemplateArray={legalPhaseTemplateArray}
        legalRequirementTemplate={currentRequirementTemplateEdit}
      ></EditLegalRequirementTemplate>

      <TableRow>
        <TableCell>
          <Checkbox
            checked={selectedRequirementsIds.includes(
              currentRequirement.idLegalRequirementTemplate
            )}
            onChange={handleCheckboxChange}
          />
        </TableCell>
        <TableCell>{currentRequirement.LegalRequirementTemplate}</TableCell>
        <TableCell>
          {legalRequirementArray
            .filter(
              x =>
                x.idLegalRequirementTemplate ===
                currentRequirementTemplateEdit.Predecessor_idLegalRequirementTemplate
            )
            .map(x => (
              <Typography sx={{ mr: 3 }} variant='caption'>
                {x.LegalRequirementTemplate}
              </Typography>
            ))}
        </TableCell>
        <TableCell>
          <IconButton
            sx={{ float: 'right' }}
            size='small'
            disabled={isLastDisabled()}
            onClick={getDown}
          >
            <ArrowDownward />
          </IconButton>

          <IconButton
            sx={{ float: 'right' }}
            size='small'
            disabled={isFirstDisabled()}
            onClick={getUp}
          >
            <ArrowUpward />
          </IconButton>
        </TableCell>
        <TableCell>
          {currentRequirement.isInterneLegalRequirement ? 'Ja' : 'Nein'}
        </TableCell>
        <TableCell>
          {currentRequirement.canUploadFilesClient ? 'Ja' : 'Nein'}
        </TableCell>
        <TableCell>
          {currentRequirement.canUploadFilesEmployees ? 'Ja' : 'Nein'}
        </TableCell>
        <TableCell>{currentRequirement.sendMail ? 'Ja' : 'Nein'}</TableCell>
        <TableCell>
          <IconButton
            size='small'
            onClick={() => {
              setCurrentRequirementTemplateEdit(
                currentRequirement.DocumentArray
                  ? currentRequirement
                  : { ...currentRequirement, DocumentArray: [] }
              );
              setIsOpenEditLegalRequirementTemplate(true);
            }}
          >
            <Edit />
          </IconButton>
          <ConfirmDelete
            itemText='die aktulle Bedingung'
            functionToDelete={handleDelete}
          />
        </TableCell>
      </TableRow>
    </>
  );
};
